export default __webpack_public_path__ + "static/image11-22b3fccd2ba0a97e3d93be8f8cb65ec9.jpg";